import { DiscountItem } from '../types'

/**
 * Parses a JSON string containing discount information
 * @param discountJson - JSON string containing discount array
 * @returns Array of DiscountItem objects or empty array if parsing fails
 */
export const parseDiscounts = (discountJson: string): DiscountItem[] => {
  if (!discountJson) return []

  try {
    const discountsArray = JSON.parse(discountJson) as DiscountItem[]
    return Array.isArray(discountsArray) ? discountsArray : []
  } catch (error) {
    console.error('Failed to parse discounts JSON:', error)
    return []
  }
}
